import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Row from 'react-bootstrap/lib/Row';

import SidePanel from './SidePanel';
import SyncCalendar from './SyncCalendar';
import FooterButton from './FooterButton';
import IncrementButton from '../IncrementButton';
import CommonFormComponent from '../CommonField/CommonFormComponent';

import validateStep3 from './validateStep3';
import updateStep3 from './updateStep3';
import messages from '../../locale/jsonMessages';
import { getDynamicName, getDynamicPolicyName } from '../../helpers/GetDynamicItemName/getDynamicName';

import locationIcon from '/public/SiteIcons/locationIdea.svg';

import cs from '../commonStyle.css';
import s from './ListPlaceStep1.css';

class MinminDays extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    listId: PropTypes.number.isRequired,
    listingSteps: PropTypes.shape({
      step3: PropTypes.string.isRequired,
      listing: PropTypes.shape({
        isPublished: PropTypes.bool.isRequired
      })
    }),
  };

  static defaultProps = {
    minDayData: 0,
    maxDayData: 0,
    listingSteps: {
      step3: "inactive",
      listing: {
        isPublished: false
      }
    },
  }

  constructor(props) {
    super(props);
    this.state = {
      isDisabled: false,
      minNight: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      maxNight: {
        itemName: null,
        otherItemName: null,
        startValue: 0,
        endValue: 0
      },
      isEqual: false
    };
  }

  UNSAFE_componentWillMount() {
    const { listingFields } = this.props;
    if (listingFields != undefined) {
      this.setState({
        minNight: listingFields?.minNight[0],
        maxNight: listingFields?.maxNight[0],
      });
    }
  }

  componentDidMount() {
    const { cancellationPolicies, cancelPolicy } = this.props;
    const { locale } = this.props.intl;
    if (cancellationPolicies?.length > 0) {
      let itemListData = cancelPolicy ? cancellationPolicies?.filter(policy => { if (policy?.id == cancelPolicy) return policy; }) : cancellationPolicies[0];
      this.setState({
        policyContent: itemListData && itemListData[0] ? itemListData[0]?.policyContent : itemListData?.policyContent
      });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { listingFields } = nextProps;
    const { cancellationPolicies, cancelPolicy } = nextProps;
    const { locale } = this.props.intl;

    if (cancellationPolicies?.length > 0) {
      let itemListData = cancelPolicy ? cancellationPolicies?.filter(policy => { if (policy?.id == cancelPolicy) return policy; }) : cancellationPolicies[0];
      let itemDynamicListData = cancellationPolicies && itemListData?.length > 0 ? itemListData[0]?.dynamicCancellationContent?.filter(policy => policy?.cancellationId == cancelPolicy) : [];
      let dynamicPolicyContent = getDynamicPolicyName({ locale, data: itemDynamicListData, value: itemListData[0] })
      this.setState({
        policyContent: dynamicPolicyContent ? dynamicPolicyContent?.policyContent : (itemListData && itemListData[0] ? itemListData[0]?.policyContent : itemListData?.policyContent)
      });
    }
    if (listingFields != undefined) {
      this.setState({
        minNight: listingFields?.minNight[0],
        maxNight: listingFields?.maxNight[0],
      });
    }
  }

  handleCancellation = () => {
    const { cancellationPolicies, cancelPolicy } = this.props;
    const { locale } = this.props.intl;
    let itemListData = cancellationPolicies && cancellationPolicies?.length > 0 ? cancellationPolicies?.filter(policy => policy?.id == cancelPolicy) : [];
    let itemDynamicListData = cancellationPolicies && itemListData?.length > 0 ? itemListData[0]?.dynamicCancellationContent?.filter(policy => policy?.cancellationId == cancelPolicy) : [];
    let dynamicPolicyContent = getDynamicPolicyName({ locale, data: itemDynamicListData, value: itemListData[0] })
    this.setState({
      policyContent: dynamicPolicyContent ? dynamicPolicyContent?.policyContent : (itemListData && itemListData[0] ? itemListData[0].policyContent : '')
    });
  }
  renderIncrementButton = ({ input, label, meta: { error, dirty }, stayNight, labelSingluar, labelPlural }) => {
    const { formatMessage } = this.props.intl;
    const { minDayData, maxDayData } = this.props;
    const { minNight, maxNight } = this.state;
    let disableButton = false;
    if (minDayData > maxDayData) {
      this.setState({
        isDisabled: true
      })
      disableButton = true
    }

    return (
      <div>
        <label className='commonLabelText'>{label}</label>
        <IncrementButton
          {...input}
          labelSingluar={labelSingluar || stayNight?.itemName}
          labelPlural={labelPlural || stayNight?.otherItemName}
          maxValue={stayNight.endValue}
          minValue={stayNight.startValue}
          incrementBy={1}
        />
        {dirty && disableButton && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }

  render() {
    const { handleSubmit, previousPage, nextPage, formPage, step } = this.props;
    const { listingSteps, listId, locale, dynamicLanguageData } = this.props;
    const { cancellationPolicies, cancelPolicy } = this.props;
    const { formatMessage } = this.props.intl;
    const { minNight, maxNight, policyContent } = this.state;
    let dynamicMinNight, dynamicMaxNight;
    dynamicMinNight = getDynamicName({ value: minNight, locale, data: dynamicLanguageData })
    dynamicMaxNight = getDynamicName({ value: maxNight, locale, data: dynamicLanguageData })

    return (
      <div className={cx(s.stepGrid, 'stepGridRTL')}>
        <SidePanel
          title={formatMessage(messages.step3Heading)}
          landingContent={formatMessage(messages.availabilityTripText)}
        />
        <form onSubmit={handleSubmit}>
          <div className={cx(s.landingMainContent, s.minMaxMobile)}>
            <div className="oneColumnGrid">
              <Field name="maxDaysNotice" component={CommonFormComponent} inputClass='commonSelectField' labelText={formatMessage(messages.availabilityWindowText)} >
                <option value={"available"}>{formatMessage(messages.datesOption5)}</option>
                <option value={"3months"}>{formatMessage(messages.datesOption1)}</option>
                <option value={"6months"}>{formatMessage(messages.datesOption2)}</option>
                <option value={"9months"}>{formatMessage(messages.datesOption3)}</option>
                <option value={"12months"}>{formatMessage(messages.datesOption4)}</option>
                <option value={"unavailable"}>{formatMessage(messages.datesDropDown)}</option>
              </Field>

              <div className='twoColumnGrid'>
                <Field
                  name="minDay"
                  component={this.renderIncrementButton}
                  stayNight={minNight}
                  labelSingluar={dynamicMinNight?.itemName}
                  labelPlural={dynamicMinNight?.otherItemName}
                  label={formatMessage(messages.minTripLength)}
                />

                <Field
                  name="maxDay"
                  component={this.renderIncrementButton}
                  stayNight={maxNight}
                  labelSingluar={dynamicMaxNight?.itemName}
                  labelPlural={dynamicMaxNight?.otherItemName}
                  label={formatMessage(messages.maxTripLength)}
                />
              </div>

              <Field name="cancellationPolicy"
                component={CommonFormComponent}
                inputClass='commonSelectField'
                labelText={formatMessage(messages.chooseCancellationPolicy)}
                isNote
                note={
                  <div>
                    <img src={locationIcon} className={cx(cs.positionRelative, cs.topMinus3)} />&nbsp;
                    <span className={cx(s.locationTipCss, cs.commonMediumText)}>{policyContent}</span>
                  </div>
                }
              >
                <option value={"1"}>{formatMessage(messages.flexible)}</option>
                <option value={"2"}>{formatMessage(messages.moderate)}</option>
                <option value={"3"}>{formatMessage(messages.strict)}</option>
              </Field>
              <span>{ }</span>

              {
                listingSteps?.step3 === "completed" && listingSteps.listing && listingSteps.listing.isPublished &&
                <div>
                  <label className='commonLabelText'><FormattedMessage {...messages.syncCalendars} /></label>
                  <SyncCalendar listId={listId} />
                </div>
              }
            </div>
          </div>
          <FooterButton
            nextPage={nextPage}
            previousPage={previousPage}
            nextPagePath={"calendar"}
            previousPagePath={"discount"}
            formPage={formPage}
            step={step}
          />
        </form>
      </div>
    );
  }
}

// Decorate with connect to read form values
const selector = formValueSelector('ListPlaceStep3'); // <-- same as form name

MinminDays = reduxForm({
  form: 'ListPlaceStep3', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate: validateStep3,
  onSubmit: updateStep3
})(MinminDays);

const mapState = (state) => ({
  minDayData: selector(state, 'minDay'),
  maxDayData: selector(state, 'maxDay'),
  cancelPolicy: selector(state, 'cancellationPolicy'),
  listingFields: state?.listingFields?.data,
  listingSteps: state?.location?.listingSteps,
  cancellationPolicies: state?.location?.cancellationPolicies,
  locale: state?.intl?.locale,
  dynamicLanguageData: state?.dynamicListSettings?.data,
  dynamicCancellationData: state?.dynamicListTitles?.data?.dynamicCancellationData
});

const mapDispatch = {
};

export default injectIntl(withStyles(cs, s)(connect(mapState, mapDispatch)(MinminDays)));
